/**
 * Wrap the provided string in double quotes and escape and double quote characters present in the string.
 */
export const quoteString = (str: string) => `"${str.replace(/"/g, '\\"')}"`;
